/**
 * Router Selectors
 */

import { createSelector } from 'reselect';

export const getRouterState = ({ found }: IStoreState) => found;
export const getLocationPathname = createSelector(
  getRouterState,
  ({ match }) => match.location.pathname,
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/selectors/router.ts